module.exports = __webpack_public_path__ + "img/common-box.ce2f7bbc.png";